import { createReducer, on } from '@ngrx/store';
import { resetAllCustomPdfReportItems } from '../actions';
import { setShowBenchmarkOption } from './show-benchmark-option.actions';
import { ShowBenchmarkOption } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/show-benchmark-option.enum';
export const showBenchmarkOption = createReducer(ShowBenchmarkOption.MODULE_DEFAULT, on(setShowBenchmarkOption, (state, action) => {
    return action.showBenchmarkOption;
}), on(resetAllCustomPdfReportItems, () => {
    return ShowBenchmarkOption.MODULE_DEFAULT;
}));
